import { render, staticRenderFns } from "./PostInfo.vue?vue&type=template&id=29e3f76d"
import script from "./PostInfo.vue?vue&type=script&lang=js"
export * from "./PostInfo.vue?vue&type=script&lang=js"
import style0 from "./PostInfo.vue?vue&type=style&index=0&id=29e3f76d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports